import camelCase from 'lodash-es/camelCase'
import Ticketure from '@/types/ticketure-api.types'

/**
 * Get metadata for single category
 */
export const getMetaDataForCategory = (
  categoryId: string,
  metaData: Transformed.MetaData[],
): Transformed.MetaData[] => (
  metaData.filter((metaItem) => metaItem.resourceId === categoryId)
)

/**
 * Get metadata for a list of categories
 */
export const getMetadataForCategories = (
  categories: Transformed.TicketCategory[],
  metaData: Transformed.MetaData[],
): Transformed.MetaData[] => {
  const categoryIds = categories.map((category) => (
    category.id
  ))

  // only meta belonging to categories in the session
  return metaData.filter((metaItem) => categoryIds.includes(metaItem.resourceId))
}

const transformMetaData = (metaList: Ticketure.Meta | undefined): Transformed.MetaData[] => {
  const data = metaList ? metaList._data : []

  return data.map((meta) => ({
    value: meta.value.trim(),
    metakey: camelCase(meta.metakey),
    resource: meta.resource,
    resourceId: meta.resource_id,
  }))
}

export default transformMetaData
